import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        biz_id: "",
        secretkey: "",
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        appid: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        biz_id: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        secretkey: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    reqFn = _this2.formData.id ? 'appRealnameAuthConfigTypeUpdate' : 'appRealnameAuthConfigTypeAdd';

                    _this2.$api[reqFn](_objectSpread(_objectSpread({}, _this2.formData), {}, {
                      isMustAppid: 1
                    })).then(function (res) {
                      if (res.status == 200) {
                        _this2.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};